import { registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { SvgIconConfig } from './token';
import { SVG_ICON_CONFIG, SVG_ICON_DOMAIN_NUMBER_STR } from './token';

type Options = {
  svgIconConfig: SvgIconConfig;
  domainNumberStr: string;
};

export function configureSvgIcons(options: Options): void {
  registerDiToken(SVG_ICON_CONFIG, () => options.svgIconConfig);
  registerDiToken(SVG_ICON_DOMAIN_NUMBER_STR, () => options.domainNumberStr);
}
